<template>
  <b-card no-body class="p-3" v-loading="is_loading">
    <b-row>
      <b-col cols="12">
        <h3>Summary Report</h3>

        <div class="card-table-simple">
          <b-table-simple responsive bordered>
            <b-tbody>
              <b-tr>
                <b-th>Clients Name</b-th>
                <b-td><b>{{ !_gHlp.isEmpty(activeCustomer) ? activeCustomer.name : '-' }}</b></b-td>
              </b-tr>
              <b-tr>
                <b-th>Approval Loan Amount</b-th>
                <b-td><b>RM {{ formData.loan_amount | moneyFormatter }}</b></b-td>
              </b-tr>
              <!-- <b-tr>
                <b-th>Stamp Duty</b-th>
                <b-td>RM {{ formData.stamp_duty | moneyFormatter }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Vetting and Facilitation + SST ({{ sst_rate }} %)</b-th>
                <b-td>RM {{ formData.vet_fac_amt | moneyFormatter }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Stakeholder Sum ({{ formData.stakeholder_mth || 0 }} Months)</b-th>
                <b-td>RM {{ formData.stakeholder_sum | moneyFormatter }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Legal Fee + SST ({{ sst_rate }} %)</b-th>
                <b-td>RM {{ formData.legal_fees | moneyFormatter }}</b-td>
              </b-tr> -->
              <b-tr>
                <b-th class="d-flex align-items-center justify-content-between border-0">
                  Debt Consolidation Items
                  <div>
                    <b-icon :icon="show ? 'chevron-down' : 'chevron-right'" @click="toggleDetails"
                      class="cursor-pointer"></b-icon>
                  </div>
                </b-th>
                <b-td>RM {{ formData.debt_consolidation_amount | moneyFormatter }}</b-td>
              </b-tr>
              <template v-if="show">
                <b-tr v-for="(item, index) in formData.ccrisItemsSettleList" :key="'c' + index">
                  <b-th><i>- {{ item.loan_statue + (item.bank_name ? ` - ${item.bank_name}` : '') }}</i></b-th>
                  <b-td><i>RM {{ item.invinity_solution | moneyFormatter }}</i></b-td>
                </b-tr>
                <b-tr v-for="(item, index) in formData.nonCcrisItemsSettleList" :key="'n' + index">
                  <b-th><i>- {{ item.loan_statue + (item.bank_name ? ` - ${item.bank_name}` : '') }}</i></b-th>
                  <b-td><i>RM {{ item.invinity_solution | moneyFormatter }}</i></b-td>
                </b-tr>
                <b-tr v-for="(item, index) in formData.othPaymentItemsList" :key="'o' + index">
                  <b-th ><i>- {{ item.type + (item.description ? ` - ${item.description}` : '') }}</i></b-th>
                  <b-td><i>RM {{ item.settlement | moneyFormatter }}</i></b-td>
                </b-tr>
                <!-- <b-tr >
									<b-th class="d-flex align-items-center justify-content-between border-0">
										<i>- Fees & Charges</i>
										<div>
											<b-icon :icon="show_fees ? 'chevron-down' : 'chevron-right'" @click="toggleDetailsFees"
												class="cursor-pointer"></b-icon>
										</div>
									</b-th>
									<b-td><i><u>RM {{ total_charges_fees | moneyFormatter }}</u></i></b-td>
								</b-tr>
								<template v-if="show_fees">
									<b-tr>
										<b-td><i class="pl-4">-- Stamp Duty</i></b-td>
										<b-td class="bg-warning">
											<CurrencyInput v-model="formData.stamp_duty" :disabled="isViewOnly"
												@blur="changeLoan(false)"
												:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
										</b-td>
									</b-tr>
									<b-tr>
										<b-td><i class="pl-4">-- Vetting and Facilitation</i></b-td>
										<b-td class="bg-warning">
											<CurrencyInput v-model="formData.vet_fac_amt" :disabled="isViewOnly"
												@blur="changeLoan(false)"
												:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
										</b-td>
									</b-tr>
									<b-tr>
										<b-td><i class="pl-4">-- Stakeholder Sum</i></b-td>
										<b-td class="bg-warning">
											<CurrencyInput v-model="formData.stakeholder_sum" :disabled="isViewOnly"
												@blur="changeLoan(false)"
												:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
										</b-td>
									</b-tr>
									<b-tr>
										<b-td><i class="pl-4">-- Legal Fees</i></b-td>
										<b-td class="bg-warning">
											<CurrencyInput v-model="formData.legal_fees" :disabled="isViewOnly"
												@blur="changeLoan(false)"
												:options="{ currency: 'MYR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true }" />
										</b-td>
									</b-tr>
								</template> -->
              </template>
              <b-tr>
                <b-th>Bal Disbursement Amount</b-th>
                <b-td><b>RM {{ this.formData.bal_disbursement_amount | moneyFormatter }}</b></b-td>
              </b-tr>
              <!-- <b-tr>
                <b-th>Advance Payment</b-th>
                <b-td><b>RM {{ this.formData.adv_payment_amount | moneyFormatter }}</b></b-td>
              </b-tr> -->
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="card-table-simple">
          <b-table-simple responsive bordered>
            <b-tbody>
              <b-tr v-if="formData.moratorium_eligible">
                <b-th>Monthly Installment</b-th>
                <b-td>RM {{ formData.installment_amount | moneyFormatter }}</b-td>
              </b-tr>
              <b-tr v-if="formData.moratorium_eligible">
                <b-th>Moratorium Period</b-th>
                <b-td>{{ formData.moratorium_tenure }} {{ formData.moratorium_tenure_period }}</b-td>
              </b-tr>
              <b-tr v-if="formData.moratorium_eligible">
                <b-th>Moratorium Installment</b-th>
                <b-td>RM {{ formData.moratorium_installment | moneyFormatter }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Status</b-th>
                <b-td>{{ _gHlp.getValue(activeLoanEC,'status','Pending Submission') }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </b-col>
    </b-row>
		<!-- <div class="text-right p-2" v-if="!isViewOnly">
			<el-button type="danger" class="mx-1" size="mini" @click="resetFees"
				icon="el-icon-refresh-left">Reset Fees</el-button>

			<el-button type="warning" class="mx-1" size="mini" @click="submitAndCalculate"
				icon="el-icon-circle-check">Save
				& Calculate</el-button>
		</div> -->
  </b-card>
</template>
<script>
import { Button } from 'element-ui';
import { swal } from '@/assets/js/httpImports.js';
import { Collapse, CollapseItem } from 'element-ui';
import CurrencyInput from '@/components/CurrencyInput'
import { mapActions, mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';

export default {
	props: [
		'is-view-only',
	],
  components: {
		CurrencyInput,
    [Button.name]: Button,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
  },
  data() {
    return {
      show: false,
      show_fees: false,
			formData:{
				stamp_duty:0,
				stamping_fee_prc:0,
				stakeholder_sum:0,
				stakeholder_mth:0,
				vet_fac_prc:0,
				vet_fac_sst:8,
				vet_fac_amt:0,
				legal_fees:0,
				legal_base_amt:0,
				legal_sst_prc:0,
				debt_consolidation_amount:0,
				bal_disbursement_amount:0
			}
    }
  },
	beforeDestroy() {
		this.clearComponent()
	},
	beforeUnmount(){
		this.clearComponent()
	},
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer','activeLoanEC','activeFormLoanEc']),
		sst_rate(){
			return _gHlp.getValue(this.formData,'selectedLoanType.sst_rate',8)
		},
		// total_charges_fees() {
		// 	return parseFloat(_gHlp.getValue(this.formData, 'stamp_duty', 0)) + parseFloat(_gHlp.getValue(this.formData, 'vet_fac_amt', 0)) + parseFloat(_gHlp.getValue(this.formData, 'stakeholder_sum', 0)) + parseFloat(_gHlp.getValue(this.formData, 'legal_fees', 0))
		// }
		is_loading(){
			return _gHlp.isLoading('fetch_loan_type') || _gHlp.isLoading('calc_loan_eligible') || _gHlp.isLoading('calc_loan_calculator') || _gHlp.isLoading('fetch_ccris_items') || _gHlp.isLoading('fetch_non_ccris_items') || _gHlp.isLoading('fetch_oth_payment_items') || _gHlp.isLoading('fetch_loan_ec')
		}
  },
  watch: {
		activeFormLoanEc: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.formData = { ...this.formData, ...newVal }
					// this.count()
				}
			},
			immediate: true
		}
  },
  methods: {
    ...mapActions(useCustomerStore, ['updateLoanEC','setFormLoanEc']),
		clearComponent(){
			this.show = false
      this.show_fees = false
			this.formData = {
				stamp_duty:0,
				stamping_fee_prc:0,
				stakeholder_sum:0,
				stakeholder_mth:0,
				vet_fac_prc:0,
				vet_fac_sst:8,
				vet_fac_amt:0,
				legal_fees:0,
				legal_base_amt:0,
				legal_sst_prc:0,
				debt_consolidation_amount:0,
				bal_disbursement_amount:0
			}
		},
    toggleDetails() {
      this.show = !this.show
    },
    toggleDetailsFees() {
      this.show_fees = !this.show_fees
    },
		changeLoan(with_save = false) {
			this.setFormLoanEc(this.formData)
			this.$emit('change', with_save);
		},
		submitAndCalculate() {
			this.changeLoan(true)
		},
		resetFees() {
			swal.fire({
				title: 'Confirmation',
				text: "Are you sure reset all fees and recalculate by default ?",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.formData.stamp_duty = 0;
					this.formData.stakeholder_sum = 0;
					this.formData.vet_fac_amt = 0;
					this.formData.legal_fees = 0;
					this.changeLoan(true)
				}
			});
		}
    // count() {
    //   this.formData.debt_consolidation_amount = 0;
    //   this.formData.bal_disbursement_amount = 0;
		// 	// this.formData.stamp_duty = Math.round((parseFloat(this.formData.loan_amount) || 0) / 1000) * 1000 * 0.005; Move to rule78

    //   if (!_gHlp.isEmpty(this.formData.ccrisItemsSettleList) && this.formData.ccrisItemsSettleList.length > 0) {
    //     this.formData.ccrisItemsSettleList.forEach(el => {
    //       this.formData.debt_consolidation_amount += el.invinity_solution;
    //     });
    //   }
    //   if (!_gHlp.isEmpty(this.formData.nonCcrisItemsSettleList) && this.formData.nonCcrisItemsSettleList.length > 0) {
    //     this.formData.nonCcrisItemsSettleList.forEach(el => {
    //       this.formData.debt_consolidation_amount += el.invinity_solution;
    //     });
    //   }
    //   if (!_gHlp.isEmpty(this.formData.othPaymentItemsList) && this.formData.othPaymentItemsList.length > 0) {
    //     this.formData.othPaymentItemsList.forEach(el => {
    //       this.formData.debt_consolidation_amount += el.settlement;
    //     });
    //   }
		// 	this.formData.bal_disbursement_amount = parseFloat(this.formData.loan_amount) - this.formData.stamp_duty - this.formData.debt_consolidation_amount;
    // }
  }
}
</script>